// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue2-dropzone/dist/vue2Dropzone.css
// module id = 967
// module chunks = 1